import { StyleSheet } from "react-native";

import type { UiTheme } from "../theme";

// La colonna delle porte d'accesso, in UN posto solo.
//
// ⛔ Perché esiste: `WelcomeForm` e `ForgotPasswordForm` avevano lo stesso
// `makeStyles` copiato riga per riga — stessa larghezza, stesso padding, stesso
// commento sui 320dp. Due copie che possono divergere sono il difetto; la terza
// porta che arriva le farebbe tre. La review l'ha alzato su `RW-49` e si
// collassa lì, non «quando capita».
//
// Ogni form ci aggiunge sopra ciò che è SUO (le righe delle regole, il
// grassetto dell'email): questo non prova a servire tutti, tiene solo il
// mestiere condiviso.
export function authFormStyles(theme: UiTheme) {
  const { palette: p, spacing: s, typography: ty } = theme;
  return StyleSheet.create({
    // ⚠️ `paddingHorizontal` oltre alla larghezza: a 320dp — il banco più
    // stretto — una colonna larga esattamente 320 va a filo dei due bordi e il
    // testo tocca il vetro. Visto in uno scatto, non dedotto.
    wrap: {
      width: 320,
      maxWidth: "100%",
      paddingHorizontal: s.s4,
      gap: s.s4,
    },
    title: { color: p.ink, fontSize: ty.sizes.xl, fontWeight: "700" },
    help: {
      color: p.ink2,
      fontSize: ty.sizes.base,
      lineHeight: ty.sizes.base * ty.leading.base,
      marginBottom: s.s3,
    },
    // ⛔ 44 al CALLSITE, non dentro `TextField`: le forme fitte restano a 36
    // (`PrescribeHeaderFields.tsx:113` l'ha già deciso). Su una porta i campi
    // SONO lo schermo.
    field: { minHeight: 44 },
    // La tipografia la porta `FieldLabel`; qui resta solo la spaziatura.
    label: { marginBottom: s.s2 },
    error: { color: p.danger, fontSize: ty.sizes.base },
    // Il link secondario delle porte: testo sottolineato, nessuna scatola.
    //
    // ⛔ Sale qui perché la terza copia sarebbe arrivata adesso. Le due che
    // c'erano — `backHit`/`back` in `ForgotPasswordForm` e `contactHit`/`contact`
    // in `SignInForm` — si commentavano già a vicenda come lo stesso mestiere, e
    // `PROF-6` ne aggiunge due callsite in un colpo solo. Il pavimento dei 44 sta
    // nello stile e non in `hitSlop` perché react-native-web `hitSlop` lo ignora.
    // ⏳ `SignInForm` non consuma ancora questo modulo (ha un suo `makeStyles`):
    // la sua adozione è in `consolidation.md`, boy-scout quando si tocca il file.
    linkHit: { minHeight: 44, justifyContent: "center", alignSelf: "center" },
    link: {
      color: p.ink,
      fontSize: ty.sizes.sm,
      textDecorationLine: "underline",
    },
    // Same mute as Button's disabled box.
    linkDisabled: { opacity: 0.5 },
  });
}
